var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 13.6 8 C 13.6 8.331 13.331 8.6 13 8.6 L 4.49 8.6 L 7.816 11.768 C 7.978 11.915 8.047 12.138 7.997 12.351 C 7.946 12.564 7.784 12.732 7.573 12.791 C 7.363 12.849 7.137 12.788 6.984 12.632 L 2.584 8.432 C 2.467 8.319 2.4 8.163 2.4 8 C 2.4 7.837 2.467 7.681 2.584 7.568 L 6.984 3.368 C 7.137 3.212 7.363 3.151 7.573 3.209 C 7.784 3.268 7.946 3.436 7.997 3.649 C 8.047 3.862 7.978 4.085 7.816 4.232 L 4.49 7.4 L 13 7.4 C 13.331 7.4 13.6 7.669 13.6 8 Z",
    fill: "rgba(108, 114, 132, 0.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationLeft);
export default __webpack_public_path__ + "static/media/PaginationLeft.e1ced97c4e0b94220bd13c908b67716a.svg";
export { ForwardRef as ReactComponent };